import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/images/admin.jpg'


const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-5 col-xl-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-7 col-xl-8" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "leads-details-tabs" }, [
    /*#__PURE__*/_createElementVNode("ul", {
      class: "nav nav-tabs border-0 mb-25",
      id: "myTab",
      role: "tablist"
    }, [
      /*#__PURE__*/_createElementVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        /*#__PURE__*/_createElementVNode("button", {
          class: "nav-link fs-md-15 fs-lg-16 fw-medium border-0 rounded-0 d-block text-center w-100 active",
          id: "tasks-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#tasks-tab-pane",
          type: "button",
          role: "tab",
          "aria-controls": "tasks-tab-pane",
          "aria-selected": "true"
        }, " Tasks ")
      ]),
      /*#__PURE__*/_createElementVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        /*#__PURE__*/_createElementVNode("button", {
          class: "nav-link fs-md-15 fs-lg-16 fw-medium border-0 rounded-0 d-block text-center w-100",
          id: "deals-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#deals-tab-pane",
          type: "button",
          role: "tab",
          "aria-controls": "deals-tab-pane",
          "aria-selected": "false"
        }, " Deals ")
      ]),
      /*#__PURE__*/_createElementVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        /*#__PURE__*/_createElementVNode("button", {
          class: "nav-link fs-md-15 fs-lg-16 fw-medium border-0 rounded-0 d-block text-center w-100",
          id: "emails-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#emails-tab-pane",
          type: "button",
          role: "tab",
          "aria-controls": "emails-tab-pane",
          "aria-selected": "false"
        }, " Emails ")
      ]),
      /*#__PURE__*/_createElementVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        /*#__PURE__*/_createElementVNode("button", {
          class: "nav-link fs-md-15 fs-lg-16 fw-medium border-0 rounded-0 d-block text-center w-100",
          id: "attachments-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#attachments-tab-pane",
          type: "button",
          role: "tab",
          "aria-controls": "attachments-tab-pane",
          "aria-selected": "false"
        }, " Attachments ")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "tab-content",
      id: "myTabContent"
    }, [
      /*#__PURE__*/_createElementVNode("div", {
        class: "tab-pane fade show active",
        id: "tasks-tab-pane",
        role: "tabpanel",
        tabindex: "0"
      }, [
        /*#__PURE__*/_createElementVNode("div", { class: "card mb-25 border-0 rounded-0 bg-white to-do-list-box letter-spacing" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "card-head bg-white d-md-flex align-items-center justify-content-between pt-15 pb-15 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30" }, [
            /*#__PURE__*/_createElementVNode("h5", { class: "card-title fw-bold mb-0" }, "Tasks"),
            /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center mt-10 mt-md-0" }, [
              /*#__PURE__*/_createElementVNode("form", { class: "search-box position-relative me-15" }, [
                /*#__PURE__*/_createElementVNode("input", {
                  type: "text",
                  class: "form-control shadow-none text-black rounded-0 border-0",
                  placeholder: "Search task"
                }),
                /*#__PURE__*/_createElementVNode("button", {
                  type: "submit",
                  class: "bg-transparent text-primary transition p-0 border-0"
                }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search-interface-symbol" })
                ])
              ]),
              /*#__PURE__*/_createElementVNode("button", {
                class: "dot-btn lh-1 position-relative top-3 bg-transparent border-0 shadow-none p-0 transition d-inline-block",
                type: "button"
              }, [
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "card-body pt-0 pb-15 pb-sm-20 pb-md-25 pb-lg-30 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30" }, [
            /*#__PURE__*/_createElementVNode("ul", { class: "to-do-list ps-0 list-unstyled mb-0" }, [
              /*#__PURE__*/_createElementVNode("li", { class: "to-do-list-item d-sm-flex align-items-center justify-content-between" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-primary mb-0 fs-md-15 fs-lg-16 text-black fw-medium" }, [
                  /*#__PURE__*/_createElementVNode("input", {
                    class: "form-check-input shadow-none",
                    type: "checkbox",
                    id: "task1"
                  }),
                  /*#__PURE__*/_createElementVNode("label", {
                    class: "form-check-label",
                    for: "task1"
                  }, " Design a Facebook Ad "),
                  /*#__PURE__*/_createElementVNode("span", { class: "fs-12 text-muted fw-normal ms-5" }, " 19 Mar, 2024 ")
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "action-buttons mt-10 mt-sm-0 d-flex align-items-center" }, [
                  /*#__PURE__*/_createElementVNode("button", { class: "bg-transparent p-0 border-0 text-black transition lh-1" }, [
                    /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-pen" })
                  ]),
                  /*#__PURE__*/_createElementVNode("button", { class: "bg-transparent p-0 border-0 text-black transition lh-1 ms-10 ms-md-20" }, [
                    /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-trash" })
                  ])
                ])
              ]),
              /*#__PURE__*/_createElementVNode("li", { class: "to-do-list-item d-sm-flex align-items-center justify-content-between" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-primary mb-0 fs-md-15 fs-lg-16 text-black fw-medium" }, [
                  /*#__PURE__*/_createElementVNode("input", {
                    class: "form-check-input shadow-none",
                    type: "checkbox",
                    id: "task2"
                  }),
                  /*#__PURE__*/_createElementVNode("label", {
                    class: "form-check-label",
                    for: "task2"
                  }, " Analyze Dashboard Data "),
                  /*#__PURE__*/_createElementVNode("span", { class: "fs-12 text-muted fw-normal ms-5" }, "18 Mar, 2024")
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "action-buttons mt-10 mt-sm-0 d-flex align-items-center" }, [
                  /*#__PURE__*/_createElementVNode("button", { class: "bg-transparent p-0 border-0 text-black transition lh-1" }, [
                    /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-pen" })
                  ]),
                  /*#__PURE__*/_createElementVNode("button", { class: "bg-transparent p-0 border-0 text-black transition lh-1 ms-10 ms-md-20" }, [
                    /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-trash" })
                  ])
                ])
              ]),
              /*#__PURE__*/_createElementVNode("li", { class: "to-do-list-item d-sm-flex align-items-center justify-content-between" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-primary mb-0 fs-md-15 fs-lg-16 text-black fw-medium" }, [
                  /*#__PURE__*/_createElementVNode("input", {
                    class: "form-check-input shadow-none",
                    type: "checkbox",
                    id: "task3"
                  }),
                  /*#__PURE__*/_createElementVNode("label", {
                    class: "form-check-label",
                    for: "task3"
                  }, " Market And Consumer Insights "),
                  /*#__PURE__*/_createElementVNode("span", { class: "fs-12 text-muted fw-normal ms-5" }, "17 Mar, 2024")
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "action-buttons mt-10 mt-sm-0 d-flex align-items-center" }, [
                  /*#__PURE__*/_createElementVNode("button", { class: "bg-transparent p-0 border-0 text-black transition lh-1" }, [
                    /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-pen" })
                  ]),
                  /*#__PURE__*/_createElementVNode("button", { class: "bg-transparent p-0 border-0 text-black transition lh-1 ms-10 ms-md-20" }, [
                    /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-trash" })
                  ])
                ])
              ]),
              /*#__PURE__*/_createElementVNode("li", { class: "to-do-list-item d-sm-flex align-items-center justify-content-between" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-primary mb-0 fs-md-15 fs-lg-16 text-black fw-medium" }, [
                  /*#__PURE__*/_createElementVNode("input", {
                    class: "form-check-input shadow-none",
                    type: "checkbox",
                    id: "task4"
                  }),
                  /*#__PURE__*/_createElementVNode("label", {
                    class: "form-check-label",
                    for: "task4"
                  }, " Review Dashboard Design "),
                  /*#__PURE__*/_createElementVNode("span", { class: "fs-12 text-muted fw-normal ms-5" }, "16 Mar, 2024")
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "action-buttons mt-10 mt-sm-0 d-flex align-items-center" }, [
                  /*#__PURE__*/_createElementVNode("button", { class: "bg-transparent p-0 border-0 text-black transition lh-1" }, [
                    /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-pen" })
                  ]),
                  /*#__PURE__*/_createElementVNode("button", { class: "bg-transparent p-0 border-0 text-black transition lh-1 ms-10 ms-md-20" }, [
                    /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-trash" })
                  ])
                ])
              ]),
              /*#__PURE__*/_createElementVNode("li", { class: "to-do-list-item d-sm-flex align-items-center justify-content-between" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-primary mb-0 fs-md-15 fs-lg-16 text-black fw-medium" }, [
                  /*#__PURE__*/_createElementVNode("input", {
                    class: "form-check-input shadow-none",
                    type: "checkbox",
                    id: "task5"
                  }),
                  /*#__PURE__*/_createElementVNode("label", {
                    class: "form-check-label",
                    for: "task5"
                  }, " Stockholder Meeting "),
                  /*#__PURE__*/_createElementVNode("span", { class: "fs-12 text-muted fw-normal ms-5" }, "15 Mar, 2024")
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "action-buttons mt-10 mt-sm-0 d-flex align-items-center" }, [
                  /*#__PURE__*/_createElementVNode("button", { class: "bg-transparent p-0 border-0 text-black transition lh-1" }, [
                    /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-pen" })
                  ]),
                  /*#__PURE__*/_createElementVNode("button", { class: "bg-transparent p-0 border-0 text-black transition lh-1 ms-10 ms-md-20" }, [
                    /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-trash" })
                  ])
                ])
              ]),
              /*#__PURE__*/_createElementVNode("li", { class: "to-do-list-item d-sm-flex align-items-center justify-content-between" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-primary mb-0 fs-md-15 fs-lg-16 text-black fw-medium" }, [
                  /*#__PURE__*/_createElementVNode("input", {
                    class: "form-check-input shadow-none",
                    type: "checkbox",
                    id: "task6"
                  }),
                  /*#__PURE__*/_createElementVNode("label", {
                    class: "form-check-label",
                    for: "task6"
                  }, " Taking Interview "),
                  /*#__PURE__*/_createElementVNode("span", { class: "fs-12 text-muted fw-normal ms-5" }, "14 Mar, 2024")
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "action-buttons mt-10 mt-sm-0 d-flex align-items-center" }, [
                  /*#__PURE__*/_createElementVNode("button", { class: "bg-transparent p-0 border-0 text-black transition lh-1" }, [
                    /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-pen" })
                  ]),
                  /*#__PURE__*/_createElementVNode("button", { class: "bg-transparent p-0 border-0 text-black transition lh-1 ms-10 ms-md-20" }, [
                    /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-trash" })
                  ])
                ])
              ])
            ]),
            /*#__PURE__*/_createElementVNode("a", {
              href: "#",
              class: "card-link-btn text-decoration-none text-primary fw-medium position-relative d-inline-block mt-10 mt-sm-25",
              "data-bs-toggle": "modal",
              "data-bs-target": "#createNewTaskModal"
            }, "Add A New Task")
          ])
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "card-head bg-white d-md-flex align-items-center justify-content-between pt-15 pb-15 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30" }, [
            /*#__PURE__*/_createElementVNode("h5", { class: "card-title fw-bold mb-0" }, "Deals"),
            /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center mt-10 mt-md-0" }, [
              /*#__PURE__*/_createElementVNode("form", { class: "search-box position-relative me-15" }, [
                /*#__PURE__*/_createElementVNode("input", {
                  type: "text",
                  class: "form-control shadow-none text-black rounded-0 border-0",
                  placeholder: "Search task"
                }),
                /*#__PURE__*/_createElementVNode("button", {
                  type: "submit",
                  class: "bg-transparent text-primary transition p-0 border-0"
                }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search-interface-symbol" })
                ])
              ]),
              /*#__PURE__*/_createElementVNode("button", {
                class: "dot-btn lh-1 position-relative top-3 bg-transparent border-0 shadow-none p-0 transition d-inline-block mt-10 mt-sm-0",
                type: "button"
              }, [
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "card-body pt-0 pb-15 pb-sm-20 pb-md-25 pb-lg-30 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "table-responsive" }, [
              /*#__PURE__*/_createElementVNode("table", { class: "table text-nowrap align-middle mb-0" }, [
                /*#__PURE__*/_createElementVNode("thead", null, [
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                    }, " Deal Name "),
                    /*#__PURE__*/_createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Amout "),
                    /*#__PURE__*/_createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Status "),
                    /*#__PURE__*/_createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Probability "),
                    /*#__PURE__*/_createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Closing Date "),
                    /*#__PURE__*/_createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                    })
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("tbody", null, [
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("th", { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "form-check d-flex align-items-center mb-0" }, [
                        /*#__PURE__*/_createElementVNode("input", {
                          class: "form-check-input shadow-none me-8 mt-0",
                          type: "checkbox"
                        }),
                        /*#__PURE__*/_createTextVNode(" J. Ronan ")
                      ])
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " $ 6,400,000.00 "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium" }, [
                      /*#__PURE__*/_createElementVNode("span", { class: "badge text-outline-success" }, "Won Deal")
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " ronanjohnny@gmail.com "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " 13 Apr, 2024 "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "dropdown" }, [
                        /*#__PURE__*/_createElementVNode("button", {
                          class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                          type: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, [
                          /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
                        ]),
                        /*#__PURE__*/_createElementVNode("ul", { class: "dropdown-menu" }, [
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" View")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Edit")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Delete")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("th", { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "form-check d-flex align-items-center mb-0" }, [
                        /*#__PURE__*/_createElementVNode("input", {
                          class: "form-check-input shadow-none me-8 mt-0",
                          type: "checkbox"
                        }),
                        /*#__PURE__*/_createTextVNode(" J. Pinkman ")
                      ])
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " $ 100,000.00 "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium" }, [
                      /*#__PURE__*/_createElementVNode("span", { class: "badge text-outline-info" }, "New Deal")
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " pinky321@gmail.com "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " 12 Apr, 2024 "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "dropdown" }, [
                        /*#__PURE__*/_createElementVNode("button", {
                          class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                          type: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, [
                          /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
                        ]),
                        /*#__PURE__*/_createElementVNode("ul", { class: "dropdown-menu" }, [
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" View")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Edit")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Delete")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("th", { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "form-check d-flex align-items-center mb-0" }, [
                        /*#__PURE__*/_createElementVNode("input", {
                          class: "form-check-input shadow-none me-8 mt-0",
                          type: "checkbox"
                        }),
                        /*#__PURE__*/_createTextVNode(" A. Carter ")
                      ])
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " $ 1,840,000.00 "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium" }, [
                      /*#__PURE__*/_createElementVNode("span", { class: "badge text-outline-danger" }, "Cancelled")
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " ronanjohnny@gmail.com "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " 13 Apr, 2024 "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "dropdown" }, [
                        /*#__PURE__*/_createElementVNode("button", {
                          class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                          type: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, [
                          /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
                        ]),
                        /*#__PURE__*/_createElementVNode("ul", { class: "dropdown-menu" }, [
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" View")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Edit")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Delete")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("th", { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "form-check d-flex align-items-center mb-0" }, [
                        /*#__PURE__*/_createElementVNode("input", {
                          class: "form-check-input shadow-none me-8 mt-0",
                          type: "checkbox"
                        }),
                        /*#__PURE__*/_createTextVNode(" V. Loper ")
                      ])
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " $ 6,400,000.00 "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium" }, [
                      /*#__PURE__*/_createElementVNode("span", { class: "badge text-outline-success" }, "Won Deal")
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " lopervic@gmail.com "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " 13 Apr, 2024 "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "dropdown" }, [
                        /*#__PURE__*/_createElementVNode("button", {
                          class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                          type: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, [
                          /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
                        ]),
                        /*#__PURE__*/_createElementVNode("ul", { class: "dropdown-menu" }, [
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" View")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Edit")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Delete")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("th", { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "form-check d-flex align-items-center mb-0" }, [
                        /*#__PURE__*/_createElementVNode("input", {
                          class: "form-check-input shadow-none me-8 mt-0",
                          type: "checkbox"
                        }),
                        /*#__PURE__*/_createTextVNode(" W. White ")
                      ])
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " $ 100,000.00 "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium" }, [
                      /*#__PURE__*/_createElementVNode("span", { class: "badge text-outline-info" }, "New Deal")
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " whitespace@gmail.com "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " 10 Apr, 2024 "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "dropdown" }, [
                        /*#__PURE__*/_createElementVNode("button", {
                          class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                          type: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, [
                          /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
                        ]),
                        /*#__PURE__*/_createElementVNode("ul", { class: "dropdown-menu" }, [
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" View")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Edit")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Delete")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("th", { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "form-check d-flex align-items-center mb-0" }, [
                        /*#__PURE__*/_createElementVNode("input", {
                          class: "form-check-input shadow-none me-8 mt-0",
                          type: "checkbox"
                        }),
                        /*#__PURE__*/_createTextVNode(" T. Skyler ")
                      ])
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " $ 400,000.00 "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium" }, [
                      /*#__PURE__*/_createElementVNode("span", { class: "badge text-outline-danger" }, "Cancelled")
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " ronanjohnny@gmail.com "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " 13 Apr, 2024 "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "dropdown" }, [
                        /*#__PURE__*/_createElementVNode("button", {
                          class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                          type: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, [
                          /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
                        ]),
                        /*#__PURE__*/_createElementVNode("ul", { class: "dropdown-menu" }, [
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" View")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Edit")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Delete")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center" }, [
              /*#__PURE__*/_createElementVNode("a", {
                href: "#",
                class: "card-link-btn text-decoration-none text-primary fw-medium position-relative d-inline-block",
                "data-bs-toggle": "modal",
                "data-bs-target": "#createNewDealModal"
              }, "Add A New Deal"),
              /*#__PURE__*/_createElementVNode("div", { class: "pagination-area d-md-flex align-items-center mt-10 mt-md-0" }, [
                /*#__PURE__*/_createElementVNode("p", { class: "mb-0 text-paragraph" }, [
                  /*#__PURE__*/_createTextVNode(" Showing "),
                  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "11"),
                  /*#__PURE__*/_createTextVNode(" out of "),
                  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "134"),
                  /*#__PURE__*/_createTextVNode(" results ")
                ]),
                /*#__PURE__*/_createElementVNode("nav", { class: "mt-12 mt-md-0 ms-md-20" }, [
                  /*#__PURE__*/_createElementVNode("ul", { class: "pagination mb-0" }, [
                    /*#__PURE__*/_createElementVNode("li", { class: "page-item" }, [
                      /*#__PURE__*/_createElementVNode("a", {
                        class: "page-link",
                        href: "#",
                        "aria-label": "Previous"
                      }, [
                        /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chevron-1" })
                      ])
                    ]),
                    /*#__PURE__*/_createElementVNode("li", { class: "page-item" }, [
                      /*#__PURE__*/_createElementVNode("a", {
                        class: "page-link active",
                        href: "#"
                      }, "1")
                    ]),
                    /*#__PURE__*/_createElementVNode("li", { class: "page-item" }, [
                      /*#__PURE__*/_createElementVNode("a", {
                        class: "page-link",
                        href: "#"
                      }, "2")
                    ]),
                    /*#__PURE__*/_createElementVNode("li", { class: "page-item" }, [
                      /*#__PURE__*/_createElementVNode("a", {
                        class: "page-link",
                        href: "#"
                      }, "3")
                    ]),
                    /*#__PURE__*/_createElementVNode("li", { class: "page-item" }, [
                      /*#__PURE__*/_createElementVNode("a", {
                        class: "page-link",
                        href: "#",
                        "aria-label": "Next"
                      }, [
                        /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chevron" })
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "card-head bg-white d-md-flex align-items-center justify-content-between pt-15 pb-15 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30" }, [
            /*#__PURE__*/_createElementVNode("h5", { class: "card-title fw-bold mb-0" }, "Emails"),
            /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center mt-10 mt-md-0" }, [
              /*#__PURE__*/_createElementVNode("form", { class: "search-box position-relative me-15" }, [
                /*#__PURE__*/_createElementVNode("input", {
                  type: "text",
                  class: "form-control shadow-none text-black rounded-0 border-0",
                  placeholder: "Search email"
                }),
                /*#__PURE__*/_createElementVNode("button", {
                  type: "submit",
                  class: "bg-transparent text-primary transition p-0 border-0"
                }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search-interface-symbol" })
                ])
              ]),
              /*#__PURE__*/_createElementVNode("button", {
                class: "dot-btn lh-1 position-relative top-3 bg-transparent border-0 shadow-none p-0 transition d-inline-block mt-10 mt-sm-0",
                type: "button"
              }, [
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "card-body pt-0 pb-15 pb-sm-20 pb-md-25 pb-lg-30 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "table-responsive" }, [
              /*#__PURE__*/_createElementVNode("table", { class: "table text-nowrap align-middle mb-0" }, [
                /*#__PURE__*/_createElementVNode("thead", null, [
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                    }, " Subject "),
                    /*#__PURE__*/_createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Sent By "),
                    /*#__PURE__*/_createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Status "),
                    /*#__PURE__*/_createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Date "),
                    /*#__PURE__*/_createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                    })
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("tbody", null, [
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("th", { class: "shadow-none lh-1 fw-medium text-black-emphasis title fs-md-15 fs-lg-16 ps-0" }, [
                      /*#__PURE__*/_createTextVNode(" Design a Facebook Ad "),
                      /*#__PURE__*/_createElementVNode("span", { class: "d-block fs-13 mt-10 text-muted fw-normal" }, "ronanjohnny@gmail.com")
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " J. Ronan "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium" }, [
                      /*#__PURE__*/_createElementVNode("span", { class: "badge text-outline-warning" }, "Bounce")
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " 13 Apr, 2024 "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "dropdown" }, [
                        /*#__PURE__*/_createElementVNode("button", {
                          class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                          type: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, [
                          /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
                        ]),
                        /*#__PURE__*/_createElementVNode("ul", { class: "dropdown-menu" }, [
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" View")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Edit")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Delete")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("th", { class: "shadow-none lh-1 fw-medium text-black-emphasis title fs-md-15 fs-lg-16 ps-0" }, [
                      /*#__PURE__*/_createTextVNode(" Analyze Dashboard Data "),
                      /*#__PURE__*/_createElementVNode("span", { class: "d-block fs-13 mt-10 text-muted fw-normal" }, "ronanjohnny@gmail.com")
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " W. White "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium" }, [
                      /*#__PURE__*/_createElementVNode("span", { class: "badge text-outline-info" }, "Draft")
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " 12 Apr, 2024 "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "dropdown" }, [
                        /*#__PURE__*/_createElementVNode("button", {
                          class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                          type: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, [
                          /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
                        ]),
                        /*#__PURE__*/_createElementVNode("ul", { class: "dropdown-menu" }, [
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" View")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Edit")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Delete")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("th", { class: "shadow-none lh-1 fw-medium text-black-emphasis title fs-md-15 fs-lg-16 ps-0" }, [
                      /*#__PURE__*/_createTextVNode(" Review Dashboard Design "),
                      /*#__PURE__*/_createElementVNode("span", { class: "d-block fs-13 mt-10 text-muted fw-normal" }, "ronanjohnny@gmail.com")
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " V. Loper "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium" }, [
                      /*#__PURE__*/_createElementVNode("span", { class: "badge text-outline-danger" }, "Spam")
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " 11 Apr, 2024 "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "dropdown" }, [
                        /*#__PURE__*/_createElementVNode("button", {
                          class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                          type: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, [
                          /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
                        ]),
                        /*#__PURE__*/_createElementVNode("ul", { class: "dropdown-menu" }, [
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" View")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Edit")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Delete")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("th", { class: "shadow-none lh-1 fw-medium text-black-emphasis title fs-md-15 fs-lg-16 ps-0" }, [
                      /*#__PURE__*/_createTextVNode(" Taking Interview "),
                      /*#__PURE__*/_createElementVNode("span", { class: "d-block fs-13 mt-10 text-muted fw-normal" }, "ronanjohnny@gmail.com")
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " A. Carter "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium" }, [
                      /*#__PURE__*/_createElementVNode("span", { class: "badge text-outline-success" }, "Sent")
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " 10 Apr, 2024 "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "dropdown" }, [
                        /*#__PURE__*/_createElementVNode("button", {
                          class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                          type: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, [
                          /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
                        ]),
                        /*#__PURE__*/_createElementVNode("ul", { class: "dropdown-menu" }, [
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" View")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Edit")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Delete")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("th", { class: "shadow-none lh-1 fw-medium text-black-emphasis title fs-md-15 fs-lg-16 ps-0" }, [
                      /*#__PURE__*/_createTextVNode(" Stockholder Meeting "),
                      /*#__PURE__*/_createElementVNode("span", { class: "d-block fs-13 mt-10 text-muted fw-normal" }, "ronanjohnny@gmail.com")
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " J. Pinkman "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium" }, [
                      /*#__PURE__*/_createElementVNode("span", { class: "badge text-outline-primary" }, "Delivered")
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " 09 Apr, 2024 "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "dropdown" }, [
                        /*#__PURE__*/_createElementVNode("button", {
                          class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                          type: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, [
                          /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
                        ]),
                        /*#__PURE__*/_createElementVNode("ul", { class: "dropdown-menu" }, [
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" View")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Edit")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Delete")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "card mb-25 border-0 rounded-0 bg-white attachments-box" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "mb-15 mb-md-20 mb-lg-25 d-sm-flex align-items-center justify-content-between" }, [
              /*#__PURE__*/_createElementVNode("h5", { class: "card-title fw-bold mb-0" }, "Attachments")
            ]),
            /*#__PURE__*/_createElementVNode("ul", { class: "list ps-0 mb-0 list-unstyled" }, [
              /*#__PURE__*/_createElementVNode("li", null, [
                /*#__PURE__*/_createElementVNode("span", { class: "fw-medium d-block fs-md-15 fs-lg-16" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-image lh-1 position-relative text-primary top-2 me-5" }),
                  /*#__PURE__*/_createTextVNode(" Adlash_1.png ")
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center text-muted mt-5" }, [
                  /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "555kb"),
                  /*#__PURE__*/_createElementVNode("span", { class: "w-6 h-6 rounded-circle bg-muted ms-8 me-8" }),
                  /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "J. Ronan"),
                  /*#__PURE__*/_createElementVNode("span", { class: "w-6 h-6 rounded-circle bg-muted ms-8 me-8" }),
                  /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "13 Apr, 2024")
                ]),
                /*#__PURE__*/_createElementVNode("img", {
                  src: _imports_0,
                  alt: "admin",
                  width: "100",
                  class: "mt-10"
                })
              ]),
              /*#__PURE__*/_createElementVNode("li", null, [
                /*#__PURE__*/_createElementVNode("span", { class: "fw-medium d-block fs-md-15 fs-lg-16" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-image lh-1 position-relative text-primary top-2 me-5" }),
                  /*#__PURE__*/_createTextVNode(" Adlash_2.png ")
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center text-muted mt-5" }, [
                  /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "1MB"),
                  /*#__PURE__*/_createElementVNode("span", { class: "w-6 h-6 rounded-circle bg-muted ms-8 me-8" }),
                  /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "J. Pinkman"),
                  /*#__PURE__*/_createElementVNode("span", { class: "w-6 h-6 rounded-circle bg-muted ms-8 me-8" }),
                  /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "12 Apr, 2024")
                ])
              ]),
              /*#__PURE__*/_createElementVNode("li", null, [
                /*#__PURE__*/_createElementVNode("span", { class: "fw-medium d-block fs-md-15 fs-lg-16" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-image lh-1 position-relative text-primary top-2 me-5" }),
                  /*#__PURE__*/_createTextVNode(" Adlash_3.png ")
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center text-muted mt-5" }, [
                  /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "472kb"),
                  /*#__PURE__*/_createElementVNode("span", { class: "w-6 h-6 rounded-circle bg-muted ms-8 me-8" }),
                  /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "A. Carter"),
                  /*#__PURE__*/_createElementVNode("span", { class: "w-6 h-6 rounded-circle bg-muted ms-8 me-8" }),
                  /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "11 Apr, 2024")
                ])
              ]),
              /*#__PURE__*/_createElementVNode("li", null, [
                /*#__PURE__*/_createElementVNode("span", { class: "fw-medium d-block fs-md-15 fs-lg-16" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-document lh-1 position-relative text-primary top-2 me-5" }),
                  /*#__PURE__*/_createTextVNode(" Adlash_4.txt ")
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center text-muted mt-5" }, [
                  /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "433kb"),
                  /*#__PURE__*/_createElementVNode("span", { class: "w-6 h-6 rounded-circle bg-muted ms-8 me-8" }),
                  /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "V. Loper"),
                  /*#__PURE__*/_createElementVNode("span", { class: "w-6 h-6 rounded-circle bg-muted ms-8 me-8" }),
                  /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "10 Apr, 2024")
                ])
              ])
            ])
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", {
        class: "tab-pane fade",
        id: "deals-tab-pane",
        role: "tabpanel",
        tabindex: "0"
      }, [
        /*#__PURE__*/_createElementVNode("div", { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "card-head bg-white d-md-flex align-items-center justify-content-between pt-15 pb-15 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30" }, [
            /*#__PURE__*/_createElementVNode("h5", { class: "card-title fw-bold mb-0" }, "Deals"),
            /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center mt-10 mt-md-0" }, [
              /*#__PURE__*/_createElementVNode("form", { class: "search-box position-relative me-15" }, [
                /*#__PURE__*/_createElementVNode("input", {
                  type: "text",
                  class: "form-control shadow-none text-black rounded-0 border-0",
                  placeholder: "Search task"
                }),
                /*#__PURE__*/_createElementVNode("button", {
                  type: "submit",
                  class: "bg-transparent text-primary transition p-0 border-0"
                }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search-interface-symbol" })
                ])
              ]),
              /*#__PURE__*/_createElementVNode("button", {
                class: "dot-btn lh-1 position-relative top-3 bg-transparent border-0 shadow-none p-0 transition d-inline-block mt-10 mt-sm-0",
                type: "button"
              }, [
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "card-body pt-0 pb-15 pb-sm-20 pb-md-25 pb-lg-30 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "table-responsive" }, [
              /*#__PURE__*/_createElementVNode("table", { class: "table text-nowrap align-middle mb-0" }, [
                /*#__PURE__*/_createElementVNode("thead", null, [
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                    }, " Deal Name "),
                    /*#__PURE__*/_createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Amout "),
                    /*#__PURE__*/_createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Status "),
                    /*#__PURE__*/_createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Probability "),
                    /*#__PURE__*/_createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Closing Date "),
                    /*#__PURE__*/_createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                    })
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("tbody", null, [
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("th", { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "form-check d-flex align-items-center mb-0" }, [
                        /*#__PURE__*/_createElementVNode("input", {
                          class: "form-check-input shadow-none me-8 mt-0",
                          type: "checkbox"
                        }),
                        /*#__PURE__*/_createTextVNode(" J. Ronan ")
                      ])
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " $ 6,400,000.00 "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium" }, [
                      /*#__PURE__*/_createElementVNode("span", { class: "badge text-outline-success" }, "Won Deal")
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " ronanjohnny@gmail.com "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " 13 Apr, 2024 "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "dropdown" }, [
                        /*#__PURE__*/_createElementVNode("button", {
                          class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                          type: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, [
                          /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
                        ]),
                        /*#__PURE__*/_createElementVNode("ul", { class: "dropdown-menu" }, [
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" View")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Edit")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Delete")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("th", { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "form-check d-flex align-items-center mb-0" }, [
                        /*#__PURE__*/_createElementVNode("input", {
                          class: "form-check-input shadow-none me-8 mt-0",
                          type: "checkbox"
                        }),
                        /*#__PURE__*/_createTextVNode(" J. Pinkman ")
                      ])
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " $ 100,000.00 "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium" }, [
                      /*#__PURE__*/_createElementVNode("span", { class: "badge text-outline-info" }, "New Deal")
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " pinky321@gmail.com "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " 12 Apr, 2024 "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "dropdown" }, [
                        /*#__PURE__*/_createElementVNode("button", {
                          class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                          type: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, [
                          /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
                        ]),
                        /*#__PURE__*/_createElementVNode("ul", { class: "dropdown-menu" }, [
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" View")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Edit")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Delete")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("th", { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "form-check d-flex align-items-center mb-0" }, [
                        /*#__PURE__*/_createElementVNode("input", {
                          class: "form-check-input shadow-none me-8 mt-0",
                          type: "checkbox"
                        }),
                        /*#__PURE__*/_createTextVNode(" A. Carter ")
                      ])
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " $ 1,840,000.00 "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium" }, [
                      /*#__PURE__*/_createElementVNode("span", { class: "badge text-outline-danger" }, "Cancelled")
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " ronanjohnny@gmail.com "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " 13 Apr, 2024 "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "dropdown" }, [
                        /*#__PURE__*/_createElementVNode("button", {
                          class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                          type: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, [
                          /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
                        ]),
                        /*#__PURE__*/_createElementVNode("ul", { class: "dropdown-menu" }, [
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" View")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Edit")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Delete")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("th", { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "form-check d-flex align-items-center mb-0" }, [
                        /*#__PURE__*/_createElementVNode("input", {
                          class: "form-check-input shadow-none me-8 mt-0",
                          type: "checkbox"
                        }),
                        /*#__PURE__*/_createTextVNode(" V. Loper ")
                      ])
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " $ 6,400,000.00 "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium" }, [
                      /*#__PURE__*/_createElementVNode("span", { class: "badge text-outline-success" }, "Won Deal")
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " lopervic@gmail.com "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " 13 Apr, 2024 "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "dropdown" }, [
                        /*#__PURE__*/_createElementVNode("button", {
                          class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                          type: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, [
                          /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
                        ]),
                        /*#__PURE__*/_createElementVNode("ul", { class: "dropdown-menu" }, [
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" View")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Edit")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Delete")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("th", { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "form-check d-flex align-items-center mb-0" }, [
                        /*#__PURE__*/_createElementVNode("input", {
                          class: "form-check-input shadow-none me-8 mt-0",
                          type: "checkbox"
                        }),
                        /*#__PURE__*/_createTextVNode(" W. White ")
                      ])
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " $ 100,000.00 "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium" }, [
                      /*#__PURE__*/_createElementVNode("span", { class: "badge text-outline-info" }, "New Deal")
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " whitespace@gmail.com "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " 10 Apr, 2024 "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "dropdown" }, [
                        /*#__PURE__*/_createElementVNode("button", {
                          class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                          type: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, [
                          /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
                        ]),
                        /*#__PURE__*/_createElementVNode("ul", { class: "dropdown-menu" }, [
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" View")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Edit")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Delete")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("th", { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "form-check d-flex align-items-center mb-0" }, [
                        /*#__PURE__*/_createElementVNode("input", {
                          class: "form-check-input shadow-none me-8 mt-0",
                          type: "checkbox"
                        }),
                        /*#__PURE__*/_createTextVNode(" T. Skyler ")
                      ])
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " $ 400,000.00 "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium" }, [
                      /*#__PURE__*/_createElementVNode("span", { class: "badge text-outline-danger" }, "Cancelled")
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " ronanjohnny@gmail.com "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " 13 Apr, 2024 "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "dropdown" }, [
                        /*#__PURE__*/_createElementVNode("button", {
                          class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                          type: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, [
                          /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
                        ]),
                        /*#__PURE__*/_createElementVNode("ul", { class: "dropdown-menu" }, [
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" View")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Edit")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Delete")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center" }, [
              /*#__PURE__*/_createElementVNode("a", {
                href: "#",
                class: "card-link-btn text-decoration-none text-primary fw-medium position-relative d-inline-block",
                "data-bs-toggle": "modal",
                "data-bs-target": "#createNewDealModal"
              }, "Add A New Deal"),
              /*#__PURE__*/_createElementVNode("div", { class: "pagination-area d-md-flex align-items-center mt-10 mt-md-0" }, [
                /*#__PURE__*/_createElementVNode("p", { class: "mb-0 text-paragraph" }, [
                  /*#__PURE__*/_createTextVNode(" Showing "),
                  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "11"),
                  /*#__PURE__*/_createTextVNode(" out of "),
                  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "134"),
                  /*#__PURE__*/_createTextVNode(" results ")
                ]),
                /*#__PURE__*/_createElementVNode("nav", { class: "mt-12 mt-md-0 ms-md-20" }, [
                  /*#__PURE__*/_createElementVNode("ul", { class: "pagination mb-0" }, [
                    /*#__PURE__*/_createElementVNode("li", { class: "page-item" }, [
                      /*#__PURE__*/_createElementVNode("a", {
                        class: "page-link",
                        href: "#",
                        "aria-label": "Previous"
                      }, [
                        /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chevron-1" })
                      ])
                    ]),
                    /*#__PURE__*/_createElementVNode("li", { class: "page-item" }, [
                      /*#__PURE__*/_createElementVNode("a", {
                        class: "page-link active",
                        href: "#"
                      }, "1")
                    ]),
                    /*#__PURE__*/_createElementVNode("li", { class: "page-item" }, [
                      /*#__PURE__*/_createElementVNode("a", {
                        class: "page-link",
                        href: "#"
                      }, "2")
                    ]),
                    /*#__PURE__*/_createElementVNode("li", { class: "page-item" }, [
                      /*#__PURE__*/_createElementVNode("a", {
                        class: "page-link",
                        href: "#"
                      }, "3")
                    ]),
                    /*#__PURE__*/_createElementVNode("li", { class: "page-item" }, [
                      /*#__PURE__*/_createElementVNode("a", {
                        class: "page-link",
                        href: "#",
                        "aria-label": "Next"
                      }, [
                        /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chevron" })
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", {
        class: "tab-pane fade",
        id: "emails-tab-pane",
        role: "tabpanel",
        tabindex: "0"
      }, [
        /*#__PURE__*/_createElementVNode("div", { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "card-head bg-white d-md-flex align-items-center justify-content-between pt-15 pb-15 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30" }, [
            /*#__PURE__*/_createElementVNode("h5", { class: "card-title fw-bold mb-0" }, "Emails"),
            /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center mt-10 mt-md-0" }, [
              /*#__PURE__*/_createElementVNode("form", { class: "search-box position-relative me-15" }, [
                /*#__PURE__*/_createElementVNode("input", {
                  type: "text",
                  class: "form-control shadow-none text-black rounded-0 border-0",
                  placeholder: "Search email"
                }),
                /*#__PURE__*/_createElementVNode("button", {
                  type: "submit",
                  class: "bg-transparent text-primary transition p-0 border-0"
                }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search-interface-symbol" })
                ])
              ]),
              /*#__PURE__*/_createElementVNode("button", {
                class: "dot-btn lh-1 position-relative top-3 bg-transparent border-0 shadow-none p-0 transition d-inline-block mt-10 mt-sm-0",
                type: "button"
              }, [
                /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "card-body pt-0 pb-15 pb-sm-20 pb-md-25 pb-lg-30 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "table-responsive" }, [
              /*#__PURE__*/_createElementVNode("table", { class: "table text-nowrap align-middle mb-0" }, [
                /*#__PURE__*/_createElementVNode("thead", null, [
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                    }, " Subject "),
                    /*#__PURE__*/_createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Sent By "),
                    /*#__PURE__*/_createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Status "),
                    /*#__PURE__*/_createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Date "),
                    /*#__PURE__*/_createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                    })
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("tbody", null, [
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("th", { class: "shadow-none lh-1 fw-medium text-black-emphasis title fs-md-15 fs-lg-16 ps-0" }, [
                      /*#__PURE__*/_createTextVNode(" Design a Facebook Ad "),
                      /*#__PURE__*/_createElementVNode("span", { class: "d-block fs-13 mt-10 text-muted fw-normal" }, "ronanjohnny@gmail.com")
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " J. Ronan "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium" }, [
                      /*#__PURE__*/_createElementVNode("span", { class: "badge text-outline-warning" }, "Bounce")
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " 13 Apr, 2024 "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "dropdown" }, [
                        /*#__PURE__*/_createElementVNode("button", {
                          class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                          type: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, [
                          /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
                        ]),
                        /*#__PURE__*/_createElementVNode("ul", { class: "dropdown-menu" }, [
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" View")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Edit")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Delete")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("th", { class: "shadow-none lh-1 fw-medium text-black-emphasis title fs-md-15 fs-lg-16 ps-0" }, [
                      /*#__PURE__*/_createTextVNode(" Analyze Dashboard Data "),
                      /*#__PURE__*/_createElementVNode("span", { class: "d-block fs-13 mt-10 text-muted fw-normal" }, "ronanjohnny@gmail.com")
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " W. White "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium" }, [
                      /*#__PURE__*/_createElementVNode("span", { class: "badge text-outline-info" }, "Draft")
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " 12 Apr, 2024 "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "dropdown" }, [
                        /*#__PURE__*/_createElementVNode("button", {
                          class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                          type: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, [
                          /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
                        ]),
                        /*#__PURE__*/_createElementVNode("ul", { class: "dropdown-menu" }, [
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" View")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Edit")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Delete")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("th", { class: "shadow-none lh-1 fw-medium text-black-emphasis title fs-md-15 fs-lg-16 ps-0" }, [
                      /*#__PURE__*/_createTextVNode(" Review Dashboard Design "),
                      /*#__PURE__*/_createElementVNode("span", { class: "d-block fs-13 mt-10 text-muted fw-normal" }, "ronanjohnny@gmail.com")
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " V. Loper "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium" }, [
                      /*#__PURE__*/_createElementVNode("span", { class: "badge text-outline-danger" }, "Spam")
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " 11 Apr, 2024 "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "dropdown" }, [
                        /*#__PURE__*/_createElementVNode("button", {
                          class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                          type: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, [
                          /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
                        ]),
                        /*#__PURE__*/_createElementVNode("ul", { class: "dropdown-menu" }, [
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" View")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Edit")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Delete")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("th", { class: "shadow-none lh-1 fw-medium text-black-emphasis title fs-md-15 fs-lg-16 ps-0" }, [
                      /*#__PURE__*/_createTextVNode(" Taking Interview "),
                      /*#__PURE__*/_createElementVNode("span", { class: "d-block fs-13 mt-10 text-muted fw-normal" }, "ronanjohnny@gmail.com")
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " A. Carter "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium" }, [
                      /*#__PURE__*/_createElementVNode("span", { class: "badge text-outline-success" }, "Sent")
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " 10 Apr, 2024 "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "dropdown" }, [
                        /*#__PURE__*/_createElementVNode("button", {
                          class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                          type: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, [
                          /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
                        ]),
                        /*#__PURE__*/_createElementVNode("ul", { class: "dropdown-menu" }, [
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" View")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Edit")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Delete")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("th", { class: "shadow-none lh-1 fw-medium text-black-emphasis title fs-md-15 fs-lg-16 ps-0" }, [
                      /*#__PURE__*/_createTextVNode(" Stockholder Meeting "),
                      /*#__PURE__*/_createElementVNode("span", { class: "d-block fs-13 mt-10 text-muted fw-normal" }, "ronanjohnny@gmail.com")
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " J. Pinkman "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium" }, [
                      /*#__PURE__*/_createElementVNode("span", { class: "badge text-outline-primary" }, "Delivered")
                    ]),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " 09 Apr, 2024 "),
                    /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "dropdown" }, [
                        /*#__PURE__*/_createElementVNode("button", {
                          class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                          type: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, [
                          /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
                        ]),
                        /*#__PURE__*/_createElementVNode("ul", { class: "dropdown-menu" }, [
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" View")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Edit")
                            ])
                          ]),
                          /*#__PURE__*/_createElementVNode("li", null, [
                            /*#__PURE__*/_createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, [
                              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }),
                              /*#__PURE__*/_createTextVNode(" Delete")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", {
        class: "tab-pane fade",
        id: "attachments-tab-pane",
        role: "tabpanel",
        tabindex: "0"
      }, [
        /*#__PURE__*/_createElementVNode("div", { class: "card mb-25 border-0 rounded-0 bg-white attachments-box" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "mb-15 mb-md-20 mb-lg-25 d-sm-flex align-items-center justify-content-between" }, [
              /*#__PURE__*/_createElementVNode("h5", { class: "card-title fw-bold mb-0" }, "Attachments")
            ]),
            /*#__PURE__*/_createElementVNode("ul", { class: "list ps-0 mb-0 list-unstyled" }, [
              /*#__PURE__*/_createElementVNode("li", null, [
                /*#__PURE__*/_createElementVNode("span", { class: "fw-medium d-block fs-md-15 fs-lg-16" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-image lh-1 position-relative text-primary top-2 me-5" }),
                  /*#__PURE__*/_createTextVNode(" Adlash_1.png ")
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center text-muted mt-5" }, [
                  /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "555kb"),
                  /*#__PURE__*/_createElementVNode("span", { class: "w-6 h-6 rounded-circle bg-muted ms-8 me-8" }),
                  /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "J. Ronan"),
                  /*#__PURE__*/_createElementVNode("span", { class: "w-6 h-6 rounded-circle bg-muted ms-8 me-8" }),
                  /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "13 Apr, 2024")
                ]),
                /*#__PURE__*/_createElementVNode("img", {
                  src: _imports_0,
                  alt: "admin",
                  width: "100",
                  class: "mt-10"
                })
              ]),
              /*#__PURE__*/_createElementVNode("li", null, [
                /*#__PURE__*/_createElementVNode("span", { class: "fw-medium d-block fs-md-15 fs-lg-16" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-image lh-1 position-relative text-primary top-2 me-5" }),
                  /*#__PURE__*/_createTextVNode(" Adlash_2.png ")
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center text-muted mt-5" }, [
                  /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "1MB"),
                  /*#__PURE__*/_createElementVNode("span", { class: "w-6 h-6 rounded-circle bg-muted ms-8 me-8" }),
                  /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "J. Pinkman"),
                  /*#__PURE__*/_createElementVNode("span", { class: "w-6 h-6 rounded-circle bg-muted ms-8 me-8" }),
                  /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "12 Apr, 2024")
                ])
              ]),
              /*#__PURE__*/_createElementVNode("li", null, [
                /*#__PURE__*/_createElementVNode("span", { class: "fw-medium d-block fs-md-15 fs-lg-16" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-image lh-1 position-relative text-primary top-2 me-5" }),
                  /*#__PURE__*/_createTextVNode(" Adlash_3.png ")
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center text-muted mt-5" }, [
                  /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "472kb"),
                  /*#__PURE__*/_createElementVNode("span", { class: "w-6 h-6 rounded-circle bg-muted ms-8 me-8" }),
                  /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "A. Carter"),
                  /*#__PURE__*/_createElementVNode("span", { class: "w-6 h-6 rounded-circle bg-muted ms-8 me-8" }),
                  /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "11 Apr, 2024")
                ])
              ]),
              /*#__PURE__*/_createElementVNode("li", null, [
                /*#__PURE__*/_createElementVNode("span", { class: "fw-medium d-block fs-md-15 fs-lg-16" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-document lh-1 position-relative text-primary top-2 me-5" }),
                  /*#__PURE__*/_createTextVNode(" Adlash_4.txt ")
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center text-muted mt-5" }, [
                  /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "433kb"),
                  /*#__PURE__*/_createElementVNode("span", { class: "w-6 h-6 rounded-circle bg-muted ms-8 me-8" }),
                  /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "V. Loper"),
                  /*#__PURE__*/_createElementVNode("span", { class: "w-6 h-6 rounded-circle bg-muted ms-8 me-8" }),
                  /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "10 Apr, 2024")
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeadsInformation = _resolveComponent("LeadsInformation")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_LeadsInformation)
    ]),
    _hoisted_3
  ]))
}